import React from 'react';
import { has } from 'lodash';
import { IntlProvider, addLocaleData } from 'react-intl';

import ruLocaleData from 'react-intl/locale-data/ru';
import roLocaleData from 'react-intl/locale-data/ro';

import roMessages from '../../translations/locales/ro.json';

addLocaleData([...ruLocaleData, ...roLocaleData]);

type Props = {
  locale: 'ru' | 'ro',
  children?: any,
};

const DEFAULT_LOCALE = 'ru';
const MESSAGES = { ro: roMessages };

const Intl = (props: Props) => {
  const hasLocale = has(MESSAGES, props.locale);
  const locale = hasLocale ? props.locale : DEFAULT_LOCALE;
  const messages = hasLocale ? MESSAGES[props.locale] : undefined;

  return (
    <IntlProvider
      defaultLocale={DEFAULT_LOCALE}
      messages={messages}
      locale={locale}
    >
      {props.children}
    </IntlProvider>
  );
};

export default Intl;
